import Vue from 'vue';
import VueRouter from 'vue-router';
import axios from 'axios';

Vue.use(VueRouter)

const router = new VueRouter({
  mode: 'history',
  base: process.env.BASE_URL,
  scrollBehavior() {
    return { x: 0, y: 0 }
  },
  routes: [
    {
      path: '/',
      name: 'dashboard',
      component: () => import('@/views/Dashboard.vue'),
      meta: {
        protected: true,
        pageTitle: 'Dashboard',
        breadcrumb: [
          {
            text: 'Dashboard',
            active: true,
          },
        ],
      },
    },
    {
      path: '/login',
      name: 'login',
      component: () => import('@/views/Login.vue'),
      meta: {
        layout: 'full',
      },
    },
    {
      path: '/error-404',
      name: 'error-404',
      component: () => import('@/views/error/Error404.vue'),
      meta: {
        layout: 'full',
      },
    },
    {
      path: '*',
      redirect: 'error-404',
    },
    {
      path: '/visitor-users',
      name: 'visitor-users',
      component: () => import('@/views/VisitorUsers.vue'),
      meta: {
        protected: true,
        pageTitle: 'Users',
        breadcrumb: [
          {
            text: 'Users',
            active: true,
          },
        ],
      },
    },
    {
      path: '/calls',
      name: 'calls',
      component: () => import('@/views/Calls.vue'),
      meta: {
        protected: true,
        pageTitle: 'Calls',
        breadcrumb: [
          {
            text: 'Calls',
            active: true,
          },
        ],
      },
    },
  ],
})

router.beforeEach((to, from, next) => {
  const token = localStorage.getItem('userTokenBi');
  if (token) {
    axios.defaults.headers.common.Authorization = `Bearer ${token}`;
  }
  const loggedIn = !!token;
  // Authed routes that do not allow unauthed users
  if (!loggedIn && to.meta.protected) {
    next({
      path: '/login',
      query: {
        redirect: to.fullPath,
      },
    });
  }
  // UnAuthed routes that do not allow authed users
  if (loggedIn && to.meta.redirectAuthed) {
    next({
      path: '/dashboard',
    });
  }
  next();
});

export default router
